import gql from 'graphql-tag'

export const DELETE = gql`
  mutation product_course_delete($id: ID!) {
    productDelete(id: $id)
  }
`
